import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class LoadingClient {
  async fetch(page, pageSize) {
    const response = await ajaxService.get(`/client-booking?page=${page}&perPage=${pageSize}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async confirmRequest(data) {
    const response = await ajaxService.post(`/client-booking/confirm`, data);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async rejectRequest(data) {
    const response = await ajaxService.post(`/client-booking/reject`, data);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async View(id) {
    const response = await ajaxService.get(`/client-booking/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const loadingClient = new LoadingClient();

export default loadingClient;
